import React from "react";
import "./btn.css";

const Button_btn = () => {
  return (
    <div>
      <div className="wrapper">
        <a className="btn_a" href="#">Shop now</a>
      </div>
    </div>
  );
};

export default Button_btn;
